import type {
  DeleteMemberExperienceParams,
  GetMemberExperienceDetailsParams,
  GetMemberExperienceDetailsResponse,
  GetMemberExperienceParams,
  GetMemberExperienceResponse,
  ModifyMemberExperienceResponse
} from '@/models/interface/memberExperience';
import { ApiFactory, type ApiDataResponse, type ApiResponse } from '@/utils/api';

export class MemberExperienceService extends ApiFactory {
  constructor() {
    super('MemberExperience');
  }

  /**
   * 取得 學員見證列表
   * @param params - 請求參數
   */
  getMemberExperience(
    params: GetMemberExperienceParams
  ): Promise<ApiDataResponse<GetMemberExperienceResponse>> {
    return super.get(
      'GetMemberExperience',
      { ...params },
      {
        headers: {
          disableGlobalLoading: true
        }
      }
    );
  }
  /**
   * 取得 學員見證列表
   * @param params - 請求參數
   */
  getMemberExperienceDetails(
    params: GetMemberExperienceDetailsParams
  ): Promise<ApiDataResponse<GetMemberExperienceDetailsResponse>> {
    return super.get(
      'GetMemberExperienceDetails',
      { ...params },
      {
        headers: {
          disableGlobalLoading: true
        }
      }
    );
  }
  /**
   * 建立 學員見證
   * @param body - {CreateMemberExperiencePayload} 請求酬載資料
   */
  createMemberExperience(body: FormData): Promise<ApiDataResponse<ModifyMemberExperienceResponse>> {
    return super.post('CreateMemberExperience', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        disableGlobalLoading: true
      }
    });
  }
  /**
   * 更新 學員見證
   * @param body - {UpdateMemberExperiencePayload} 請求酬載資料
   */
  updateMemberExperience(body: FormData): Promise<ApiDataResponse<ModifyMemberExperienceResponse>> {
    return super.put('UpdateMemberExperience', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        disableGlobalLoading: true
      }
    });
  }
  /**
   * 刪除 學員見證
   * @param params - 請求參數
   */
  deleteMemberExperience(params: DeleteMemberExperienceParams): Promise<ApiResponse> {
    return super.deleteData(`${params.indx}/${params.memberId}`, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }
}
